<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="detailAllAssignment &&  sended" class="container text-center overflow-hidden pb-5">
  <div *ngIf="assignment">
    <div class="row justify-content-center">
      <div class="col">
        <h1 class="lifedi-color">
          {{ detailAllAssignment.ASSIGNMENT_NAME }}
        </h1>
      </div>
    </div>
    <div class="row text-left">
      <div class="col">
        <h4 class="title">
          {{ detailAllAssignment.COURSE_NUMBER }}: {{ detailAllAssignment.COURSE_NAME }}
        </h4>
      </div>
    </div>
  </div>
  <mat-tab-group>
    <mat-tab label="ยังไม่ตรวจสอบ">
      <div class="container" *ngIf="detailAllAssignment.DETAIL.length > 0" id="assignmentGroup">
        <form [formGroup]="DetailAssignment">
          <div class="row" *ngFor="let file of detailAllAssignment.DETAIL">
            <div class="col-12">
              <mat-card id="assignment-list" class="mt-3">
                <div class="row">
                  <div class="col-lg-10 col-md-12 col-sm-12">
                    <h5 style="margin: 20px;" class="text-left">
                      {{ file.FEEDBACK_DOC_ORIGINAL }} (userid : {{ file.USER_ID }}
                      {{ file.USERNAME }})
                    </h5>
                  </div>
                  <div class="col-lg-2 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-6">
                        <a data-toggle="collapse" [attr.data-target]="'#' + file.FEEDBACK_ID"
                          (click)="collapseCard(DetailAssignment)">
                          <img src="../../../../assets/reply.png" class="icon" alt="">
                        </a>
                      </div>
                      <div class="col-6">
                        <a (click)="downloadAssignment(file.FEEDBACK_DOC ,file.FEEDBACK_DOC_ORIGINAL)">
                          <img src="../../../../assets/direct-download.png" class="icon" alt="">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card>
            </div>
            <div class="col-12 justify-content-center">
              <div class="collapse" [(id)]="file.FEEDBACK_ID" data-parent="#assignmentGroup">
                <mat-card class="justify-content-center">
                  <div class="row justify-content-center">
                    <div class="col-8">
                      <div class="form-group">
                        <textarea class="form-control col-12" rows="5" id="comment"
                          formControlName="feedbackMessage"></textarea>
                      </div>
                    </div>
                    <div class="col-4" id="upload-file">
                      <h5 class="upload-text">อัปโหลดไฟล์ตรงนี้</h5>
                      <p>
                        <label *ngIf="!upLoadFile" for="upLoadFile" id="label-file">
                          Choose file
                        </label>
                        <label *ngIf="upLoadFile" for="upLoadFile" id="label-file">
                          {{ upLoadFile }}
                        </label>
                      </p>
                      <span class="btn btn-file">
                        อัปโหลด
                        <input type="file" id="upLoadFile"
                          accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          (change)="selectFile($event, DetailAssignment)">
                      </span>
                    </div>
                    <lifedi-btn lable="ส่ง" class="mt-3 mb-3" customStyle="padding: 0 40px;  color:#FFFFFF"
                      *ngIf="!DetailAssignment.valid" disabled="true">
                    </lifedi-btn>
                    <lifedi-btn lable="ส่ง" class="mt-3 mb-3"
                      customStyle="padding: 0 40px; background: rgb(0, 92, 61); color:#FFFFFF"
                      *ngIf="DetailAssignment.valid"
                      (click)="callBackFeedBack(DetailAssignment.value, file.FEEDBACK_ID)">
                    </lifedi-btn>
                  </div>
                </mat-card>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div *ngIf="detailAllAssignment.DETAIL.length === 0">
        <h4 class="mt-3 text-center">
          ไม่มีรายการที่ยังไม่ตรวจสอบ
        </h4>
      </div>
    </mat-tab>

    <mat-tab label="ตรวจสอบแล้ว">
      <div class="container mb-4" *ngIf="sended.DETAIL.length > 0" id="checkedAssignment">
        <div class="row" *ngFor="let send of sended.DETAIL">
          <div class="col-12">
            <mat-card id="assignment-list" class="mt-3">
              <div class="row">
                <div class="col-lg-10 col-md-12 col-sm-12">
                  <h5 style="margin: 20px;" class="text-left">
                    {{ send.FEEDBACK_DOC_ORIGINAL }} (userid : {{ send.USER_ID }}
                    {{ send.USERNAME }})
                  </h5>
                </div>
                <div class="col-lg-2 col-md-12 col-sm-12">
                  <div class="row">
                    <div class="col-6">
                      <a data-toggle="collapse" [attr.data-target]="'#' + send.FEEDBACK_ID">
                        <img src="../../../../assets/reply.png" class="icon" alt="">
                      </a>
                    </div>
                    <div class="col-6">
                      <a (click)="downloadAssignment(send.FEEDBACK_DOC ,send.FEEDBACK_DOC_ORIGINAL)">
                        <img src="../../../../assets/direct-download.png" class="icon" alt="">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>

          <div class="collapse col-12" [(id)]="send.FEEDBACK_ID" data-parent="#checkedAssignment">
            <div style="padding: 20px 36px; background: #fff;">
              <mat-card class="text-left" style="border: 1px solid;">
                <a
                  (click)="downloadAssignment(send.DETAIL_FEEDBACK[0].FEEDBACK_DOC, send.DETAIL_FEEDBACK[0].FEEDBACK_DOC_ORIGINAL)">
                  {{ send.DETAIL_FEEDBACK[0].FEEDBACK_DOC_ORIGINAL }}
                </a>
                <small style="display: inline; float: right;">{{ send.CREATE_DATE | dateTime }}</small>
                <p class="mt-2">{{ send.DETAIL_FEEDBACK[0].FEEDBACK_MESSAGE }}</p>

                <!-- <a class="mt-2" style="cursor: pointer; " id="feedback"
                (click)="downloadAssignment(send.DETAIL_FEEDBACK[0].FEEDBACK_DOC, send.DETAIL_FEEDBACK[0].FEEDBACK_DOC_ORIGINAL)">
                <p style="font-size: 17px;">
                  {{ send.DETAIL_FEEDBACK[0].FEEDBACK_DOC_ORIGINAL }}
                </p>
              </a>
              <P style="font-size: 17px;">
                {{ send.DETAIL_FEEDBACK[0].FEEDBACK_MESSAGE }}
              </P> -->
              </mat-card>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="sended.DETAIL.length === 0">
        <h4 class="mt-3 text-center">
          ไม่มีรายการ
        </h4>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>